import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  text: {
    textAlign: 'left' as const,
    [theme.breakpoints.down('md')]: {
      '& .MuiSelect-root': {
        whiteSpace: 'inherit',
      },
    },
  },
});
